// Module
var code = "<react-component name=\"SentBulkMessageRecipients\"></react-component>\n";
// Exports
module.exports = code;